module.exports = __webpack_public_path__ + "img/normal_multiplier_5.e0908073.png";